// extracted by mini-css-extract-plugin
export var active = "_mw-2";
export var recordingDot = "_mw-1";
export var recordingIndicator = "_mw-0";